export default {
  api: {
    url: 'https://ww-gateway-qa.wnwd.com'
  }
};
